import { X, Clock, User, Scissors } from "lucide-react";
import { Button } from "@/components/ui/button";

// "YYYY-MM-DD HH:mm:ss" -> "ДД.ММ.ГГГГ, ЧЧ:ММ" — YClients всегда отдаёт дату в этом формате,
// парсим руками вместо Date() (избегаем расхождений часовых поясов при парсинге строки без зоны).
export function formatRecordDate(dateStr) {
  if (!dateStr) return "";
  const [datePart, timePart] = dateStr.split(" ");
  const [y, m, d] = (datePart || "").split("-");
  if (!y || !m || !d) return dateStr;
  return `${d}.${m}.${y}${timePart ? `, ${timePart.slice(0, 5)}` : ""}`;
}

export default function YClientsRecordPickerModal({ client, records, onPick, onCancel, emptyActionLabel = "Продолжить без записи", emptyText = "У этого клиента нет записей в YClients" }) {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-[200] flex items-center justify-center"
      onMouseDown={e => e.target === e.currentTarget && onCancel()}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-[480px] max-w-[95vw] max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 flex-shrink-0">
          <span className="text-base font-bold text-slate-900">Записи клиента «{client.name}»</span>
          <Button variant="ghost" size="icon" onClick={onCancel} className="h-7 w-7">
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="px-5 py-4 flex flex-col gap-2.5 overflow-y-auto">
          {records === null ? (
            <div className="flex flex-col items-center gap-2 py-8 text-slate-400 text-sm">
              <div className="h-5 w-5 rounded-full border-2 border-slate-200 border-t-blue-600 animate-spin" />
              Загрузка записей...
            </div>
          ) : records.length === 0 ? (
            <div className="flex flex-col items-center gap-3 py-6 text-center">
              <p className="text-sm text-slate-500">{emptyText}</p>
              <Button onClick={() => onPick(null)}>{emptyActionLabel}</Button>
            </div>
          ) : (
            <>
              {records.map(r => (
                <button
                  key={r.id}
                  onClick={() => onPick(r.id)}
                  className="text-left rounded-xl border border-slate-200 hover:border-blue-300 hover:bg-blue-50/50 transition-colors px-4 py-3 flex flex-col gap-1.5"
                >
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-blue-600">
                    <Clock className="h-3.5 w-3.5" />
                    {formatRecordDate(r.date)}
                  </div>
                  <div className="flex items-center gap-1.5 text-sm font-medium text-slate-800">
                    <User className="h-3.5 w-3.5 text-slate-400" />
                    {client.name}
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-slate-500">
                    <Scissors className="h-3.5 w-3.5 text-slate-400" />
                    {r.services?.length ? r.services.join(", ") : "Без услуги"}
                  </div>
                </button>
              ))}
              <Button variant="ghost" className="self-center" onClick={() => onPick(null)}>Продолжить без записи</Button>
            </>
          )}
        </div>

        <div className="flex justify-end px-5 py-3 border-t border-slate-100 flex-shrink-0">
          <Button type="button" variant="ghost" onClick={onCancel}>Отмена</Button>
        </div>
      </div>
    </div>
  );
}
